'use client'

import { useTranslations } from 'next-intl'

export function openPrivacyManager(id: string) {
  if (window._sp_?.gdpr?.loadPrivacyManagerModal) {
    window._sp_.gdpr.loadPrivacyManagerModal(id)
  } else {
    // eslint-disable-next-line no-console -- part of error reporting
    console.error('window._sp_.gdpr.loadPrivacyManagerModal not available')
  }
}

export function usePrivacyManager() {
  const id = useTranslations('usePrivacyManager')('id')
  return () => openPrivacyManager(id)
}
